/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import RouteErrorBoundary from '../../components/error/RouteErrorBoundary';
import { AppRouteInterface, RouteInterface, RoutesInterface } from '../../types/routes';
import { AppLayout } from '../../layout/AppLayout';
import Logo from '../../images/g17Eco.svg';
import Header from '../../components/header';
import { AppHeader } from '../../components/header/AppHeader';
import { Stats } from '../../components/stats';
import { Company } from '../../components/stats/reports/company';
import Survey from '../../components/stats/reports/survey';
import Scope from '../../components/stats/reports/scope';
import Standards from '../../components/stats/reports/standards';
import Questions from '../../components/stats/reports/questions';
import { isStaff } from '../../selectors/user'
import NotAuthorised from '../../routes/not-authorised';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { QUESTION } from '../../constants/terminology';

export const statsRoutes: RoutesInterface = {
  STATS: {
    id: 'stats_root',
    label: 'Home',
    tooltip: 'Statistics',
    path: '/stats/',
    icon: 'fa-folder-open',
    component: StatsRoute,
    exact: false,
    auth: true,
  },
  STATS_COMPANIES: {
    id: 'stats_companies',
    label: 'Companies',
    tooltip: 'Company Statistics',
    path: '/stats/company',
    icon: 'fa-folder-open',
    component: Company,
    exact: false,
    auth: true,
  },
  STATS_SURVEY: {
    id: 'stats_survey',
    label: 'Surveys',
    tooltip: 'Survey Statistics',
    path: '/stats/survey',
    icon: 'fa-folder-open',
    component: Survey,
    exact: true,
    auth: true,
  },
  STATS_SCOPE: {
    id: 'stats_scope',
    label: 'Scopes',
    tooltip: 'Survey Scope Statistics',
    path: '/stats/scope/:scopeType?',
    icon: 'fa-folder-open',
    component: Scope,
    exact: true,
    auth: true,
  },
  STATS_STANDARDS: {
    id: 'stats_standards',
    label: 'Standards',
    tooltip: 'Standards Statistics',
    path: '/stats/standards',
    icon: 'fa-folder-open',
    component: Standards,
    exact: true,
    auth: true,
  },
  STATS_QUESTIONS: {
    id: 'stats_questions',
    label: QUESTION.CAPITALIZED_PLURAL,
    tooltip: `${QUESTION.CAPITALIZED_PLURAL} Statistics`,
    path: '/stats/questions',
    icon: 'fa-folder-open',
    component: Questions,
    exact: true,
    auth: true,
  },
}

export const statsRouteEntry: RouteInterface = {
  ...statsRoutes.STATS
};

const statsAppRoute: AppRouteInterface = {
  appName: 'Reporting',
  appIcon: Logo,
  routes: [
    {
      ...statsRoutes.STATS,
      exact: true
    },
    statsRoutes.STATS_COMPANIES,
    statsRoutes.STATS_SURVEY,
    statsRoutes.STATS_SCOPE,
    statsRoutes.STATS_STANDARDS,
    statsRoutes.STATS_QUESTIONS,
  ],
}

function StatsRoute() {

  const userIsStaff = useSelector(isStaff);

  return (
    !userIsStaff
      ?
      <Route component={NotAuthorised} />
      :
      <RouteErrorBoundary>
        <AppLayout Header={(
          <Header>
            <AppHeader appRoute={statsAppRoute} route={statsRoutes.STATS} />
          </Header>
        )}>
          <div className='stats-root'>
            <Switch>
              <Route {...statsRoutes.STATS_COMPANIES} />
              <Route {...statsRoutes.STATS_SURVEY} />
              <Route {...statsRoutes.STATS_SCOPE} />
              <Route {...statsRoutes.STATS_STANDARDS} />
              <Route {...statsRoutes.STATS_QUESTIONS} />
              <Route>
                <Stats />
              </Route>
            </Switch>
          </div>
        </AppLayout>
      </RouteErrorBoundary>
  )
}
